<template>
  <div
    :meta-error="metaError"
    :class="['input-component w-full', extraClass, isActive ? 'is-active' : '', error ? 'is-error' : '', labelVisibleAlways ? 'label-visible-always' : '', disabled && 'opacity-50', !!value && 'is-filled']"
  >
    <label class="text-xs text-gray-600 cursor-text mb-auto" :for="computedId">{{ label }}</label>

    <div class="input relative">
      <input
        :id="computedId"
        v-model="inputValue"
        :disabled="disabled"
        :placeholder="placeholder"
        :name="name"
        :type="type"
        :pattern="pattern"
        :inputmode="inputmode"
        :title="title"
        :step="step"
        :autocomplete="autocomplete"
        class="w-full text-gray-600 h-10 border-b-2 border-gray-600 rounded-none placeholder-gray-600 focus:shadow-1 focus:px-3 appearance-none outline-none xl:text-lg mt-auto"
        :class="[inputClass]"
        @focus="onFocus"
        @blur="onBlur"
        @paste="onPaste"
        @change="onChange"
      >
      <span
        v-if="optional"
        class="optional absolute right-0 bottom-0 top-0  flex items-center mr-3 text-xs text-gray-600 leading-none"
      >
        {{ $t('components.flightVoucher.form.optional') }}
      </span>
    </div>

    <p v-if="error">
      <span class="input-error bg-lh_error text-white text-xs leading-none px-2 py-px">{{ error }}</span>
    </p>
  </div>
</template>

<script lang='ts'>
import TextInput from '~components/shared/text-input'

export default TextInput.extend({})
</script>

<style lang="scss" scoped>
  .input-component {
    label {
      @apply opacity-0;
    }

    .input {
      &::before {
        content: "";
        position: absolute;
        right: 0;
        bottom: 0;
        width: 2px;
        height: 50%;

        @apply bg-gray-600;
      }
    }

    &.label-visible-always {
      label {
        @apply opacity-100;
      }
    }

    &.is-filled {
      label {
        @apply opacity-100;
      }
    }

    &.is-active {
      label {
        @apply opacity-100;
      }

      .input {
        &::before {
          display: none;
        }
      }
    }

    &.is-error {
      label {
        @apply opacity-100;
      }

      .input {
        input {
          @apply border-lh_error;
        }

        &::before {
          display: none;
        }
      }
    }
  }

  .is-optional {
    .input-component {
      input {
        padding-right: 75px; /* let's assume that word "optional" has that width in all translations */
      }
    }
  }

  .uppercase.placeholder-normal-case {
    &::-webkit-input-placeholder {
      /* WebKit browsers */
      text-transform: none;
    }

    &::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      text-transform: none;
    }

    &:-moz-placeholder {
      /* Mozilla Firefox 4 to 18 */
      text-transform: none;
    }

    &:-ms-input-placeholder {
      /* Internet Explorer 10+ */
      text-transform: none;
    }

    &::placeholder {
      /* Recent browsers */
      text-transform: none;
    }
  }
</style>
